import React from "react"

import Modal from "@/components/core/Modal/Modal"
import Button from "@/components/core/Button/Button"

const OrderWarning = props => {
  const {
    showAlert,
    closeAlert,
    i18n: {
      orderWarningTitle,
      orderWarningDesc1,
      orderWarningDesc2,
      orderWarningContinueCta,
    },
  } = props

  return (
    <div className="orderWarning">
      <Modal showModal={showAlert} onModalClose={() => closeAlert(false)}>
        <div className="order-warning__modal">
          <div className="order-warning__modal-title">{orderWarningTitle}</div>
          <div className="order-warning__modal-desc">
            {orderWarningDesc1} <br />
            {orderWarningDesc2}
          </div>
          <div className="order-warning__modal-cta">
            <Button
              className="gbh-data-layer"
              type="primary"
              label={orderWarningContinueCta}
              onClick={() => closeAlert(false)}
              tag={"button"}
            />
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default OrderWarning
